import { useCallback, useState } from "react";
import type { DdqQueueRow } from "../types";

export const useDdqDrawer = (rows: DdqQueueRow[]) => {
  const [selectedRowId, setSelectedRowId] = useState<string | undefined>(undefined);
  const [isOpen, setIsOpen] = useState(false);

  const onRowClicked = useCallback((row: DdqQueueRow) => {
    setSelectedRowId(row.id);
    setIsOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  // The row outlives `isOpen` so the drawer still has content to render on the way out.
  const onCloseAnimationComplete = useCallback(() => {
    setSelectedRowId(undefined);
  }, []);

  // Derived, not snapshotted: Apollo hands back new row objects as the cache updates.
  const selectedRow = rows.find((row) => row.id === selectedRowId);

  return { selectedRow, isOpen, onRowClicked, onClose, onCloseAnimationComplete };
};
